$(document).ready(function () {
    if (typeof Geolizr !== 'undefined') {
      Geolizr.getGeoData(function(geoData) {
        if (geoData && geoData.country && geoData.country.code) {
          const countryCode = geoData.country.code;
          const countryName = geoData.country.country;

          if (countryCode === "NZ" || countryName === "NEW ZEALAND") {
            $('.announcebar-customer-nz').show();
            $("body").addClass("customer-nz");
            checkNZMessage();
          }
        }
      });
    } else {
      console.log("Geolizr library not available, using fallback");
      $.get("https://api.ipify.org?format=json", function(ipResponse) {
        if (ipResponse && ipResponse.ip) {
          $.get("https://ipinfo.io/" + ipResponse.ip + "/json", function(geoResponse) {
            if (geoResponse && geoResponse.country) {
              const country = geoResponse.country;

              if (country === "NZ") {
                $('.announcebar-customer-nz').show();
                $("body").addClass("customer-nz");
                checkNZMessage();
              }
            }
          }, "json");
        }
      }, "json").fail(function() {
        console.log("All geolocation methods failed");
      });
    }
  });

  function checkNZMessage(){
    $(window).scroll(function() {
      var scrollPosition = $(window).scrollTop(),
          messageTop = $('.announcebar-customer-nz');
      if (messageTop.length){
        if (scrollPosition>0){
          messageTop.hide();
        }else{
          messageTop.show();
        }
      }
    });
  }
